const regionRangeMap = new Map([
	['ALL_REGION', '全境配送'],
	['PART_REGION', '部分地区提供服务']
]);

const ibuReach = {
	canReachCode: [
		'11',
		'12',
		'13',
		'21',
		'22',
		'23',
		'31',
		'32',
		'33',
		'41',
		'42',
		'43'
	], // 国际可达code
	notReachCode: ['14', '24', '34', '44'] // 国际不可达code
};

export { regionRangeMap, ibuReach };



// WEBPACK FOOTER //
// ./src/pages/receive-range/config.js